import React from 'react';
import classnames from 'classnames';

import { VideoSeekSlider } from 'react-video-seek-slider';

import VideoPlayerControls from '../components/videoPlayerControls';

import 'react-video-seek-slider/styles.css';
import styles from '../styles/video.module.scss';

const DesktopScreenSizePlayerControls = ({
  playbackRate,
  playing,
  volume,
  played,
  duration,
  fullscreen,
  hasBookmark,
  hasCaptions,
  canPlayPip,
  captionsMode,
  pip,
  handleSetPlaybackRate,
  handleSeekChange,
  handleTogglePlaying,
  handleVolumeChange,
  handleFullScreen,
  handleTogglePIP,
  handleSeekBarChange,
  handleBookmark,
  handleToggleCaptions,
}) => (
  <VideoPlayerControls>
    <div className={styles.controlActions}>
      <VideoPlayerControls.Duration played={played} duration={duration} />

      <div className={styles.middle}>
        <VideoPlayerControls.PlaybackSpeed
          playbackRate={playbackRate}
          handleSetPlaybackRate={handleSetPlaybackRate}
        />
        <VideoPlayerControls.SkipBackward handleSeekChange={handleSeekChange} />
        <VideoPlayerControls.Play playing={playing} handlePlay={handleTogglePlaying} />
        <VideoPlayerControls.SkipForward handleSeekChange={handleSeekChange} />
        <VideoPlayerControls.Volume volume={volume} handleVolumeChange={handleVolumeChange} />
      </div>

      <div className={styles.rightControls}>
        {hasBookmark && (
          <VideoPlayerControls.Bookmark handleBookmarkClick={handleBookmark} played={played} />
        )}
        {hasCaptions && (
          <VideoPlayerControls.Captions
            handleCaptionsClick={handleToggleCaptions}
            captions={captionsMode}
          />
        )}
        {canPlayPip && <VideoPlayerControls.Pip pip={pip} handleTogglePIP={handleTogglePIP} />}
        <VideoPlayerControls.Fullscreen
          fullscreen={fullscreen}
          handleFullScreen={handleFullScreen}
        />
      </div>
    </div>
    <VideoSeekSlider
      max={duration * 1000}
      currentTime={played * 1000}
      onChange={handleSeekBarChange}
      limitTimeTooltipBySides
      secondsPrefix="00:00:"
      minutesPrefix="00:"
    />
  </VideoPlayerControls>
);

const SmallScreenSizePlayerControls = ({
  playbackRate,
  playing,
  volume,
  played,
  duration,
  fullscreen,
  hasBookmark,
  hasCaptions,
  canPlayPip,
  captionsMode,
  pip,
  handleSetPlaybackRate,
  handleSeekChange,
  handleTogglePlaying,
  handleToggleCaptions,
  handleVolumeChange,
  handleFullScreen,
  handleTogglePIP,
  handleSeekBarChange,
  handleBookmark,
}) => (
  <>
    <div className={styles.smallScreenControls}>
      <VideoPlayerControls.PlaybackSpeed
        playbackRate={playbackRate}
        handleSetPlaybackRate={handleSetPlaybackRate}
      />
      <VideoPlayerControls.SkipBackward handleSeekChange={handleSeekChange} />
      <VideoPlayerControls.Play playing={playing} handlePlay={handleTogglePlaying} />
      <VideoPlayerControls.SkipForward handleSeekChange={handleSeekChange} />
      <VideoPlayerControls.Volume volume={volume} handleVolumeChange={handleVolumeChange} />
    </div>
    <div className={classnames(styles.rightControls, styles.rightControlsSmall)}>
      {hasBookmark && (
        <VideoPlayerControls.Bookmark handleBookmarkClick={handleBookmark} played={played} />
      )}
      {hasCaptions && (
        <VideoPlayerControls.Captions
          handleCaptionsClick={handleToggleCaptions}
          captionsMode={captionsMode}
        />
      )}
      {canPlayPip && <VideoPlayerControls.Pip pip={pip} handleTogglePIP={handleTogglePIP} />}
      <VideoPlayerControls.Fullscreen fullscreen={fullscreen} handleFullScreen={handleFullScreen} />
    </div>
    <VideoPlayerControls>
      <div className={styles.controlActions}>
        <VideoPlayerControls.Duration played={played} duration={duration} />
        <div className={styles.middle} />
      </div>
      <VideoSeekSlider
        max={duration * 1000}
        currentTime={played * 1000}
        progressUpdateInterval={100}
        onChange={handleSeekBarChange}
        limitTimeTooltipBySides
        secondsPrefix="00:00:"
        minutesPrefix="00:"
      />
    </VideoPlayerControls>
  </>
);

const FloatingPlayerControls = ({
  playbackRate,
  playing,
  volume,
  played,
  duration,
  fullscreen,
  hasBookmark,
  hasCaptions,
  canPlayPip,
  captionsMode,
  pip,
  handleSetPlaybackRate,
  handleSeekChange,
  handleTogglePlaying,
  handleToggleCaptions,
  handleVolumeChange,
  handleFullScreen,
  handleTogglePIP,
  handleSeekBarChange,
  handleBookmark,
}) => (
  <>
    <div className={styles.smallScreenControls}>
      <VideoPlayerControls.PlaybackSpeed
        playbackRate={playbackRate}
        handleSetPlaybackRate={handleSetPlaybackRate}
      />
      <VideoPlayerControls.SkipBackward handleSeekChange={handleSeekChange} />
      <VideoPlayerControls.Play playing={playing} handlePlay={handleTogglePlaying} />
      <VideoPlayerControls.SkipForward handleSeekChange={handleSeekChange} />
      <VideoPlayerControls.Volume volume={volume} handleVolumeChange={handleVolumeChange} />
    </div>
    <VideoPlayerControls className={styles.floatingControls}>
      <VideoSeekSlider
        max={duration * 1000}
        currentTime={played * 1000}
        progressUpdateInterval={100}
        onChange={handleSeekBarChange}
        limitTimeTooltipBySides
        secondsPrefix="00:00:"
        minutesPrefix="00:"
      />
      <div className={styles.controlActions}>
        <VideoPlayerControls.Duration played={played} duration={duration} />
        <div className={styles.middle} />
        <div className={classnames(styles.rightControls)}>
          {hasBookmark && (
            <VideoPlayerControls.Bookmark handleBookmarkClick={handleBookmark} played={played} />
          )}
          {hasCaptions && (
            <VideoPlayerControls.Captions
              handleCaptionsClick={handleToggleCaptions}
              captionsMode={captionsMode}
            />
          )}
          {canPlayPip && <VideoPlayerControls.Pip pip={pip} handleTogglePIP={handleTogglePIP} />}
          <VideoPlayerControls.Fullscreen
            fullscreen={fullscreen}
            handleFullScreen={handleFullScreen}
          />
        </div>
      </div>
    </VideoPlayerControls>
  </>
);

export default ({ screenSize, isFloating }) => {
  let ControlsElement;

  if (isFloating) {
    ControlsElement = FloatingPlayerControls;
  } else if (screenSize === 'small' || screenSize === 'xsmall') {
    ControlsElement = SmallScreenSizePlayerControls;
  } else {
    ControlsElement = DesktopScreenSizePlayerControls;
  }

  return ControlsElement;
};
